// extracted by mini-css-extract-plugin
module.exports = {"image":"section-flowercut-module--image--_0cnD"};